<template>
    <portlet
            :icon="'fad fa-user-graduate'"
            :title="'Opleidingen'"
    >
        <template slot="portletBody">
            <form v-if="Can(rights.EDUCATION_ADD)"  @submit.prevent="addEducation()">
                <div class="row align-items-end mb-5">
                    <div class="col-sm-8 col-lg-10">
                        <label for="education-name">Voeg een opleiding toe</label>
                        <input required
                               name="education-name"
                               id="education-name"
                               type="text"
                               class="form-control"
                               v-model="name">
                    </div>
                    <div class="col-sm-4 col-lg-2 education-save">
                        <button class="btn btn-primary btn-block">Toevoegen</button>
                    </div>
                </div>
            </form>
            <datatables
                    :tableClass="tableClass"
                    v-if="getAllEducations.length && renderedComponent && Can(rights.EDUCATION_VIEW)"
                    :rows="getAllEducations"
                    :columns="columns"
                    tableID="educations"
                    :tableInitOptions="tableInitOptions"
                    routerLinkClass="dt-router-link"
                    :deleteFunction="deleteEducation"
                    deleteClass="delete"
                    :getDataClass="'get-data'"
                    @rowSelected="rowSelected"
            ></datatables>

            <edit-name-default
                    v-if="education"
                    :title="'Opleiding aanpassen'"
                    :value="education"
                    :name="modalId"
                    @saveChanges="editEducation($event)"
            ></edit-name-default>

        </template>
    </portlet>
</template>

<script>
    import {mapGetters} from 'vuex'
    import editNameDefault from '../../components/editNameDefault'
    import {dataTables} from "../../components/mixins/dataTables";
    import {swalModals} from "../../components/mixins/swalModals.js";
    import { Can } from '../../../permission/ability.js';
    import { RIGHTS } from '../roles/rights';

    export default {
        mixins: [dataTables, swalModals],
        components: {editNameDefault},
        data() {
            return {
                name: '',
                education: '',
                rigths: '',
                tableInitOptions: {
                    order: [[1, "desc"]],
                },
                columns: [
                    {data: 'name', name: 'Naam', visible: true, searchable: true, responsivePriority: 1},
                    {
                        data: 'standard', name: 'Standaard', visible: true, searchable: true,
                        render(data) {
                            return (data ? '<i class="fas fa-check"></i>' : '');
                        }
                    },
                    {
                        data: null, name: 'Opties', orderable: false, responsivePriority: 2,
                        render(data) {
                            var options = '';
                            if(Can(RIGHTS.EDUCATION_EDIT)) {
                                options += '<i title="Opleiding aanpassen" class="far fa-edit action-icon get-data" data-target="#' + data.id + '" data-toggle="modal"></i>';
                            }

                            if(Can(RIGHTS.EDUCATION_DELETE)) {
                                options += '<a class="delete action-icon dt-router-link" data-id="' + data.id + '"><i title="Verwijder" class="far fa-trash-alt delete"></i></a>';
                            }
                            return options;
                        }
                    },
                ],
            }
        },
        methods: {
            Can,
            rowSelected(value) {
                this.modalId = value.id;
                this.education = {id: this.modalId, name: value.name, standard: value.standard};
            },
            addEducation() {
                this.$store.dispatch('educations/set', {name: this.name, standard: true, department: this.$store.getters.getUserData.selectedDepartment}).then(() => {
                    this.$toasted.global.successRequest({
                        message: 'Opleiding aangemaakt',
                    });
                    this.name = '';

                    this.renderComponent();
                }).catch(() => {
                    this.$toasted.global.failedRequest();
                })
            },
            editEducation(education) {
                if (education.name) {
                    let id = education.id;

                    $('.modal').modal('hide');
                    $('.modal-backdrop').remove();

                    this.$toasted.global.successRequest({
                        message: 'Opleiding aangepast',
                    });
                    this.$store.dispatch('educations/set', {
                        id,
                        name: education.name,
                        standard: education.standard
                    });

                    this.renderComponent();
                }
            },
            deleteEducation(education) {
                let id = education.id;
                this.swalDelete(education.name).then(result => {
                    if (result.value) {
                        this.$store.dispatch('educations/delete', id);

                        this.$toasted.global.successRequest({
                            message: 'Opleiding verwijderd',
                        });
                        this.renderComponent();
                    }
                })
            },
        },
        computed: {
            ...mapGetters('educations', [
                    'getAllEducations',
                ]
            ),
        },
        created() {
            this.rights = RIGHTS;
        }
    };
</script>
